export const VEHICLE_RATES = {
  'Executive Sedan': { 
    base: 15, 
    perMile: 3.5, 
    hourly: 85,
    longDistanceRate: 3.0 // For distances > 15 miles
  },
  'Luxury SUV': { 
    base: 20, 
    perMile: 4.5, 
    hourly: 95,
    longDistanceRate: 3.5 // For distances > 15 miles
  },
  'Stretch Limousine': { 
    base: 150,
    perMile: 6.0,
    hourly: 130,
    longDistanceRate: 5.0
  },
  'Sprinter Van': { 
    base: 120,
    perMile: 5.0,
    hourly: 145,
    longDistanceRate: 4.0
  },
  'Coach Bus': { 
    base: 200,
    perMile: 8.0,
    hourly: 200,
    longDistanceRate: 6.5
  },
  // Legacy support for old names
  Sedan: { 
    base: 15, 
    perMile: 3.5, 
    hourly: 85,
    longDistanceRate: 3.0
  },
  SUV: { 
    base: 20, 
    perMile: 4.5, 
    hourly: 95,
    longDistanceRate: 3.5
  }
};

export const ALL_VEHICLES = ['Executive Sedan', 'Luxury SUV', 'Stretch Limousine', 'Sprinter Van', 'Coach Bus'];